<div class="start">
    <max-loader></max-loader>
</div>